import React, { useState } from 'react';
import { Route, Routes } from 'react-router';
import { HashRouter as Router } from 'react-router-dom';
import SpotifyCallback from './spotify/SpotifyCallback';
import SongOrganizer from './SongOrganizer/SongOrganizer';
import Home from './Home';
import { ReactComponent as SunIcon } from "./media/sun.svg";
import { ReactComponent as MoonIcon } from "./media/moon.svg";
import FallbackHandler from './FallbackHandler';

export const ThemeContext = React.createContext({
  theme: "dark",
  setTheme: (theme: string) => {}
});

const App: React.FC = () => {
  const [themeVal, setTheme] = useState("dark");
  const value = { theme: themeVal, setTheme };

  return (
    <Router>
        <div className={`w-screen min-h-screen relative ${themeVal === 'dark' ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-900'}`}>
          <div className='absolute top-3 right-3 cursor-pointer' onClick={() => setTheme(b => b === "dark" ? "light" : "dark")}>{themeVal === "dark" ? <SunIcon /> : <MoonIcon />}</div>
          <ThemeContext.Provider value={value}>
            <Routes>
              <Route path='/callback' element={<SpotifyCallback />} />
              <Route path='/tool' element={<SongOrganizer />} />
              <Route path='/' element={<Home />} />
              <Route path='*' element={<FallbackHandler />} />
            </Routes>
          </ThemeContext.Provider>
        </div>
    </Router>
  );
}

export default App;
